
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18.786,
  height: 18.786,
  viewBox: "0 0 18.786 18.786"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".date_25bcd9432dc84811__cls-1{fill:none;stroke:#4a4a4a;stroke-linecap:round;stroke-linejoin:round}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "date_25bcd9432dc84811__Group_799",
  "data-name": "Group 799",
  transform: "translate(.5 .5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "date_25bcd9432dc84811__Path_225",
  "data-name": "Path 225",
  className: "date_25bcd9432dc84811__cls-1",
  d: "M3 9h17.786v10.869a.988.988 0 0 1-.988.988H3.988A.988.988 0 0 1 3 19.869z",
  transform: "translate(-3 -3.071)"
}), /*#__PURE__*/React.createElement("path", {
  id: "date_25bcd9432dc84811__Path_226",
  "data-name": "Path 226",
  className: "date_25bcd9432dc84811__cls-1",
  d: "M3.988 4H19.8a.988.988 0 0 1 .988.988v3.953H3V4.988A.988.988 0 0 1 3.988 4z",
  transform: "translate(-3 -3.012)"
}), /*#__PURE__*/React.createElement("path", {
  id: "date_25bcd9432dc84811__Line_11",
  "data-name": "Line 11",
  className: "date_25bcd9432dc84811__cls-1",
  transform: "translate(11.657)",
  d: "M0 0v3.886"
}), /*#__PURE__*/React.createElement("path", {
  id: "date_25bcd9432dc84811__Line_12",
  "data-name": "Line 12",
  className: "date_25bcd9432dc84811__cls-1",
  transform: "translate(5.829)",
  d: "M0 0v3.886"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18.786\" height=\"18.786\" viewBox=\"0 0 18.786 18.786\">\r\n    <defs>\r\n        <style>\r\n            .cls-1{fill:none;stroke:#4a4a4a;stroke-linecap:round;stroke-linejoin:round}\r\n        </style>\r\n    </defs>\r\n    <g id=\"Group_799\" data-name=\"Group 799\" transform=\"translate(.5 .5)\">\r\n        <path id=\"Path_225\" data-name=\"Path 225\" class=\"cls-1\" d=\"M3 9h17.786v10.869a.988.988 0 0 1-.988.988H3.988A.988.988 0 0 1 3 19.869z\" transform=\"translate(-3 -3.071)\"/>\r\n        <path id=\"Path_226\" data-name=\"Path 226\" class=\"cls-1\" d=\"M3.988 4H19.8a.988.988 0 0 1 .988.988v3.953H3V4.988A.988.988 0 0 1 3.988 4z\" transform=\"translate(-3 -3.012)\"/>\r\n        <path id=\"Line_11\" data-name=\"Line 11\" class=\"cls-1\" transform=\"translate(11.657)\" d=\"M0 0v3.886\"/>\r\n        <path id=\"Line_12\" data-name=\"Line 12\" class=\"cls-1\" transform=\"translate(5.829)\" d=\"M0 0v3.886\"/>\r\n    </g>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/date.25bcd9432dc8481149da416d86249d26.svg"),
        {
          React: SvgDate,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      